import type { AppState } from './app-state.js';
import type { EditorState } from '../editor-state.js';

interface AppServices {
  state: AppState<EditorState> | null;
}

const services: AppServices = {
  state: null,
};

export function setAppState(appState: AppState<EditorState>): void {
  services.state = appState;
}

export function getAppState(): AppState<EditorState> | null {
  return services.state;
}

/**
 * Components keep a stable accessor because many are upgraded before map.ts has
 * finished assembling the application. There is one authority: this module.
 */
export function consumeState(_host?: HTMLElement) {
  return {
    get value(): AppState<EditorState> | null {
      return services.state;
    },
  };
}
